import { store } from '../../../store'
import { MessageDataType } from '../types'
import { getPerpPositionsAction } from '../../../store/perp/actions/getPerpPositionsActions'
import { updatePerpPositionClearingsAction } from '../../../store/perp/actions'
import { PerpPositionClearingsRecord } from '../../../api/v1/perp'
import { WsOrderMessage } from './orders'

// Websocket message has different data structure for spot and perp, so we need to merge them
export type WsPositionClearingsRecord = PerpPositionClearingsRecord & {
  price: number
}

export function onMessagePositionChanged(data: MessageDataType) {
  switch (data.type) {
    // Receive position changed data,
    // used to display in the 'Perp/UserOrders/TradeHistory' component
    case 'position_changed':
      updatePositionChanged(data as WsOrderMessage<WsPositionClearingsRecord>)
      break
  }
}

function updatePositionChanged(
  data: WsOrderMessage<WsPositionClearingsRecord>
) {
  const state = store.getState()
  const { accountInfo } = state.account
  if (
    accountInfo &&
    accountInfo?.userId &&
    accountInfo?.userId === data.userId
  ) {
    store.dispatch(getPerpPositionsAction())
    data.data.clearingPrice = data.data.price
    store.dispatch(updatePerpPositionClearingsAction(data))
  }
}
